import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "destroyInput", "rowNumber", "categoryInput"]

  syncCategory(event) {
    const value = event.target.value
    if (this.hasCategoryInputTarget) {
      this.categoryInputTarget.value = value
    }

    this.element.querySelectorAll("[data-line-item-category-select]").forEach((select) => {
      if (select !== event.target) select.value = value
    })
  }

  toggleDelete() {
    const isMarkedForDeletion = this.destroyInputTarget.value === "1"

    if (isMarkedForDeletion) {
      // Unmark for deletion
      this.destroyInputTarget.value = "0"
      this.element.classList.remove("opacity-50", "line-through")
      this.element.style.display = ""
    } else {
      // Mark for deletion
      this.destroyInputTarget.value = "1"
      this.element.classList.add("opacity-50")
      this.element.style.display = "none"
      this.notifyDefaultMemoryRowRemoved()
    }

    // Trigger row number update on parent controller
    this.dispatch("deleted", { bubbles: true })
  }

  notifyDefaultMemoryRowRemoved() {
    const memoryKeys = Array.from(
      this.element.querySelectorAll("[data-lookup-selector-memory-key-value]")
    ).map((element) => element.dataset.lookupSelectorMemoryKeyValue).filter(Boolean)

    document.dispatchEvent(new CustomEvent("default-memory:row-removed", {
      detail: { memoryKeys }
    }))
  }
}
